/** Dispatched at every session seam (login, social login, purchase, logout) so
 *  the SubscriptionProvider refreshes the tier without a full reload.
 *  Lives in its own module (NO axios/api import graph) so plain utils/tests can
 *  import it without pulling in utils/api.js's module-scope axios.create(). */
export const AUTH_CHANGED_EVENT = "auth-changed";

/** Dispatch the auth-changed signal so the SubscriptionProvider refreshes the
 *  tier without a full reload. SSR-safe (no-ops when there is no window).
 *  Call at every token mutation: login, social login, account creation,
 *  signup completion, purchase, logout. */
export function notifyAuthChanged(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
  }
}
